export const isCoachOwnGroupEvent = ({ user, groupEvent }) => {
  if (!user || !groupEvent) return false

  const coachExternalId = groupEvent?.coach?.externalId
  const coachId = groupEvent?.coach?.id

  if (
    user?.externalId &&
    coachExternalId &&
    user.externalId === coachExternalId
  ) {
    return true
  }

  if (user?.id && coachId && user.id === coachId) {
    return true
  }

  return false
}

export const getRegistrationClosedEffective = ({ user, groupEvent }) => {
  const registrationClosed = Boolean(groupEvent?.registrationClosed)
  const isCoachOwn = isCoachOwnGroupEvent({ user, groupEvent })

  // Coaches should be able to register for their own events even if the public
  // registration window is closed.
  const shouldOverride = registrationClosed && isCoachOwn
  return shouldOverride ? false : registrationClosed
}

export const getRegistrationDisabled = ({ user, groupEvent }) => {
  const registrationClosedEffective = getRegistrationClosedEffective({
    user,
    groupEvent,
  })

  return (
    Boolean(groupEvent?.isCanceled) ||
    registrationClosedEffective ||
    Boolean(groupEvent?.registrationFull)
  )
}
